import { memo, MouseEvent } from 'react';
import { ReferenceObject } from 'models';
import Popper, { PopperProps } from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Paper, { PaperProps } from '@material-ui/core/Paper';
import MenuList, { MenuListClassKey } from '@material-ui/core/MenuList';
import { ClickAwayListener } from '@material-ui/core';

import clsx from 'clsx';
import { useStyles } from './style';

export interface MenuProps {
  MenuListClasses?: Partial<Record<MenuListClassKey, string>>;
  PopperProps?: Partial<PopperProps>;
  PaperProps?: PaperProps;
  anchorEl?: ReferenceObject | (() => ReferenceObject) | null | undefined;
  open: boolean;
  handleClose: (e: MouseEvent<EventTarget> | void) => void;
  fullWidth?: boolean;
  disabledPortal?: boolean;
  onEnter?: () => void;
  onExited?: () => void;
}

const Menu: React.FC<MenuProps> = ({
  open,
  PopperProps,
  anchorEl,
  handleClose,
  children,
  PaperProps,
  MenuListClasses,
  fullWidth,
  disabledPortal = true,
}) => {
  const classes = useStyles();
  const handleListKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      handleClose();
    }
  };

  return (
    <Popper
      {...PopperProps}
      className={classes.zIndex}
      anchorEl={anchorEl}
      open={open}
      role={undefined}
      transition
      disablePortal={disabledPortal}
      style={{
        width: fullWidth
          ? anchorEl
            ? typeof anchorEl === 'function'
              ? anchorEl().getBoundingClientRect().width
              : anchorEl.getBoundingClientRect().width
            : 'auto'
          : 'auto',
      }}
    >
      {({ TransitionProps, placement }) => (
        <Fade
          {...TransitionProps}
          style={{
            zIndex: 9,
            transformOrigin:
              placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper {...PaperProps}>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList
                autoFocusItem={open}
                onKeyDown={handleListKeyDown}
                classes={{
                  root: clsx(classes.list, MenuListClasses?.root),
                  dense: MenuListClasses?.dense,
                  padding: MenuListClasses?.padding,
                  subheader: MenuListClasses?.subheader,
                }}
              >
                {children}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};

export default memo(Menu);
